export default "__VITE_ASSET__4aNX2tZf__"